import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

const Slider = React.forwardRef(({ className, value, defaultValue, ...props }, ref) => {
  const thumbCount = (value ?? defaultValue ?? [0]).length;
  return (
    <SliderPrimitive.Root
      ref={ref}
      value={value}
      defaultValue={defaultValue}
      className={cn("relative flex w-full touch-none select-none items-center px-3", className)}
      {...props}>
      {/* `touch-none` est OBLIGATOIRE sur la piste ET sur le curseur, pas
          seulement sur la racine : `touch-action` ne s'hérite pas. Sans lui,
          un contact du doigt sur le curseur (la cible naturelle) est
          interprété par le navigateur comme un geste de défilement, qui
          annule la capture du pointeur de Radix — le curseur ne bouge alors
          PAS DU TOUT au doigt, alors qu'il fonctionne parfaitement à la
          souris. Symptôme constaté sur l'échelle d'optimisation de la
          médiathèque et sur le filtre de prix de la boutique. */}
      <SliderPrimitive.Track
        className="relative h-1.5 w-full grow touch-none overflow-hidden rounded-full bg-primary/20">
        <SliderPrimitive.Range className="absolute h-full bg-primary" />
      </SliderPrimitive.Track>
      {Array.from({ length: thumbCount }).map((_, i) => (
        <SliderPrimitive.Thumb
          key={i}
          className="relative block h-5 w-5 touch-none rounded-full border border-primary/50 bg-background shadow transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 before:content-[''] before:absolute before:-inset-3" />
      ))}
    </SliderPrimitive.Root>
  );
})
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
